<template>
  <v-dialog
    width="500"
    v-bind="$attrs"
    v-on="$listeners"
    @click:outside="onCancel"
  >
    <v-card>
      <v-card-title>
        Adicionar Segmento
      </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
        >
          <v-select
            v-model="gradeLevel"
            label="Segmento e ano"
            :items="gradeLevelGroupsAndLevels"
          />
          <v-select
            v-model="volumeSelected"
            :items="volumes"
            item-text="name"
            item-value="id"
            label="Selecione um volume"
          />
        </v-form>
      </v-card-text>
      <v-card-text>
        <div class="d-flex justify-space-between">
          <v-btn
            color="primary"
            text
            @click="onCancel"
          >
            Fechar
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="onSubmit()"
          >
            Incluir
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  components: {
  },
  data: () => ({
    gradeLevelGroupsAndLevels: [],
    gradeLevel: null,
    volumes: [],
    volumeSelected: null
  }),

  computed: {
  },

  created () {
    this.getVolumes()
    this.fetchGradeLevelGroups()
  },
  methods: {

    async fetchGradeLevelGroups () {
      this.busy = true
      const data = await this.$api.getGradeLevelGroups()
      const levels = data.map((item) => {
        return item.grade_levels.map((level) => {
          return {
            text: item.name + ' - ' + level.name,
            value: level.id
          }
        })
      })
      this.gradeLevelGroupsAndLevels = [
        { value: null, text: 'Escolha um segmento e ano' },
        ...levels.flatMap((item) => item)
      ]
      this.busy = false
    },

    async getVolumes () {
      try {
        this.volumes = await this.$api.listVolumes()
      } catch (e) {
        // console.log(e)
      }
    },

    onCancel () {
      this.$emit('resolve', false)
    },

    onSubmit () {
      const data = {
        grade_level_id: this.gradeLevel,
        volume_id: this.volumeSelected
      }
      this.$emit('resolve', data)
    }
  }
}
</script>
